import { render } from "./Stepper.vue?vue&type=template&id=47b6b9e3&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"

import "./Stepper.vue?vue&type=style&index=0&id=47b6b9e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b6b9e3"]])

export default __exports__